import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './Products.css';

function Products({ onBack, addToCart }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('all');

  useEffect(() => {
    const loadProducts = async () => {
      try {
        const companyID = localStorage.getItem('companyID');
        const response = await api.getProducts(companyID);
        console.log('API Response sample:', response.data.products?.[0]);
        setProducts(response.data.products || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    
    loadProducts();
  }, []);

  const getImageUrl = (product) => {
    // Check if productImage exists
    if (product.productImage) {
      // If it's already a full URL, use it directly
      if (product.productImage.startsWith('http')) {
        return product.productImage;
      }
      // If it's a relative path, prepend your domain
      if (product.productImage.startsWith('/')) {
        return `https://centralsoft.com.my${product.productImage}`;
      }
      // Otherwise assume it's a filename from uploads folder
      return `https://centralsoft.com.my/uploads/${product.productImage}`;
    }
    // Return null if no image
    return null;
  };

  const categories = ['all', ...new Set(products.map(p => p.category || 'General'))];
  
  const filteredProducts = products.filter(p => {
    const matchCategory = category === 'all' || p.category === category;
    const matchSearch = p.productName.toLowerCase().includes(search.toLowerCase());
    return matchCategory && matchSearch;
  });

  if (loading) {
    return (
      <div className="products-loading">
        <div className="spinner"></div>
        <p>Loading products...</p>
      </div>
    );
  }

  return (
    <div className="products-container">
      <div className="products-header">
        <button className="back-btn" onClick={onBack}>← Back to Dashboard</button>
        <h1>Products ({filteredProducts.length})</h1>
      </div>
      
      <div className="search-filter">
        <input
          type="text"
          placeholder="Search products..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />
        <select 
          value={category} 
          onChange={(e) => setCategory(e.target.value)} 
          className="category-select"
        >
          {categories.map(cat => (
            <option key={cat} value={cat}>
              {cat === 'all' ? 'All Categories' : cat}
            </option>
          ))}
        </select>
      </div>
      
      <div className="products-grid">
        {filteredProducts.map(product => {
          const imageUrl = getImageUrl(product);
          
          return (
            <div key={product.productID} className="product-card">
              <div className="product-image">
                {imageUrl ? (
                  <img 
                    src={imageUrl} 
                    alt={product.productName}
                    onError={(e) => {
                      console.log('Image failed to load:', imageUrl);
                      e.target.style.display = 'none';
                      e.target.parentElement.innerHTML = '<div class="product-image-placeholder">📦</div>';
                    }}
                  />
                ) : (
                  <div className="product-image-placeholder">📦</div>
                )}
              </div>
              <div className="product-info">
                <h3 className="product-title">{product.productName}</h3>
                <p className="product-category">{product.category || 'General'}</p>
                <div className="product-price-row">
                  <span className="product-price">RM {product.unitPrice}</span>
                  <span className={`product-stock ${product.stockLevel <= 5 ? 'low-stock' : ''}`}>
                    Stock: {product.stockLevel ?? 0}
                  </span>
                </div>
           
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Products;
